<template>
  <div class="about-page">
    <section class="page-hero">
      <img src="/img/yangtze-delta-building.webp" alt="江苏道鼎升工程检测有限公司对公工程查验服务" />
      <div class="page-hero-mask"></div>
      <div class="page-hero-content">
        <nav class="breadcrumb" aria-label="面包屑">
          <router-link to="/">首页</router-link>
          <span>/</span>
          <span>关于我们</span>
        </nav>
        <p class="eyebrow">About Daodingsheng</p>
        <h1>关于江苏道鼎升工程检测有限公司</h1>
        <p>
          江苏道鼎升工程检测有限公司面向开发商、建设单位、物业单位、工程项目和住宅交付项目，提供精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测服务。
        </p>
      </div>
    </section>

    <section class="section">
      <div class="section-inner about-layout">
        <div class="about-copy">
          <p class="eyebrow">Company Positioning</p>
          <h2>精装入场查验、过程质量巡检、报告输出与整改闭环</h2>
          <p>
            江苏道鼎升工程检测有限公司聚焦住宅项目精装入场和交付前后的质量风险控制，提供精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、工程质量检测和整改复查等服务。我们重视现场查验依据、问题记录规范、报告可读性和整改复查可追溯性，帮助项目团队把质量问题前置管理。
          </p>
          <div class="about-actions">
            <router-link class="btn btn-primary" :to="{ path: '/', hash: '#lead-form' }">获取检测方案</router-link>
            <router-link class="btn btn-ghost" to="/cases">查看服务案例</router-link>
          </div>
        </div>
        <div class="fact-grid">
          <div class="fact-card" v-for="item in facts" :key="item.title">
            <strong>{{ item.title }}</strong>
            <span>{{ item.desc }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="section muted">
      <div class="section-inner">
        <div class="section-heading">
          <p class="eyebrow">Capabilities</p>
          <h2>我们提供的项目服务能力</h2>
          <p>围绕交付质量风险，把服务能力拆成客户能理解、项目能执行、报告能引用的模块。</p>
        </div>
        <div class="capability-grid">
          <router-link
            v-for="service in services"
            :key="service.slug"
            class="capability-card"
            :to="service.path"
          >
            <i class="el-icon-s-check"></i>
            <h3>{{ service.shortTitle }}</h3>
            <p>{{ service.summary }}</p>
          </router-link>
        </div>
      </div>
    </section>

    <section class="section standard-section">
      <div class="section-inner standard-layout">
        <div>
          <p class="eyebrow">Service Standard</p>
          <h2>项目服务标准</h2>
          <p>
            对 B2B 交付项目来说，第三方查验的价值不仅是“发现问题”，更是把问题变成项目团队可执行、可跟踪、可复查的管理资料。
          </p>
        </div>
        <div class="standard-list">
          <div v-for="item in standards" :key="item.title" class="standard-item">
            <span>{{ item.index }}</span>
            <div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section muted">
      <div class="section-inner trust-layout">
        <div>
          <p class="eyebrow">Trust</p>
          <h2>资质与信任基础</h2>
          <p>以下内容来自现有官网资料和业务定位，证书编号与更多项目数据建议后续补充为可公开展示版本。</p>
        </div>
        <div class="trust-grid">
          <div class="trust-item" v-for="item in trustItems" :key="item">
            <i class="el-icon-medal"></i>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
      <div class="section-inner honor-strip">
        <img v-for="item in honorImages" :key="item" :src="item" :alt="'江苏道鼎升资质证书展示'" />
      </div>
    </section>

    <section class="section partner-section">
      <div class="section-inner">
        <div class="section-heading">
          <p class="eyebrow">Service Area</p>
          <h2>服务覆盖江苏、上海及长三角区域</h2>
          <p>可根据项目规模、交付批次和现场条件配置检测人员，支持跨城市住宅交付项目的查验、陪验和复查。</p>
        </div>
        <img class="partner-img" src="/img/friend.png" alt="江苏道鼎升合作伙伴与项目服务经验展示" />
      </div>
    </section>

    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">苏ICP备2024065706号</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050602013590" target="_blank" rel="noopener">苏公网安备32050602013590号</a>
    </div>
  </div>
</template>

<script>
import { services, trustItems } from "../data/services";
import {
  absoluteUrl,
  breadcrumbSchema,
  localBusinessSchema,
  organizationSchema,
  setSeo,
  setStructuredData
} from "../utils/seo";

export default {
  name: "GoIn",
  data() {
    return {
      services: services,
      trustItems: trustItems,
      facts: [
        { title: "第三方", desc: "独立查验视角，服务项目质量风险控制" },
        { title: "标准化", desc: "问题清单、照片记录、报告输出统一管理" },
        { title: "项目制", desc: "按户数、楼栋、交付批次安排人员进场" },
        { title: "闭环化", desc: "支持整改建议、复查确认和问题追踪" }
      ],
      standards: [
        {
          index: "01",
          title: "进场前明确查验范围",
          desc: "根据项目类型、户数、交付节点、楼栋分布和服务目标制定检测方案。"
        },
        {
          index: "02",
          title: "现场分项查验记录",
          desc: "按专业类别记录墙地面、门窗、厨卫、给排水、电气、渗漏等问题。"
        },
        {
          index: "03",
          title: "报告与清单同步输出",
          desc: "以照片、位置、问题描述和整改建议形成可追溯资料。"
        },
        {
          index: "04",
          title: "整改复查形成闭环",
          desc: "对已整改、未整改、整改不到位和新增问题进行复核记录。"
        }
      ],
      honorImages: ["/img/r6.jpg", "/img/r7.jpg", "/img/r8.jpg", "/img/r4.jpg"]
    };
  },
  mounted() {
    setSeo({
      title: "关于江苏道鼎升工程检测有限公司｜对公工程查验与质量过程管控",
      description:
        "江苏道鼎升工程检测有限公司面向开发商、建设单位、物业单位和住宅交付项目，提供精装入场查验、过程质量巡检、分户查验、交付前预验收、工程质量检测和整改复查服务。",
      path: "/goin",
      image: "/img/yangtze-delta-building.webp"
    });
    setStructuredData([
      organizationSchema(),
      localBusinessSchema(),
      {
        "@type": "AboutPage",
        name: "走进江苏道鼎升工程检测有限公司",
        url: absoluteUrl("/goin"),
        description: "江苏道鼎升工程检测有限公司公司定位、服务能力、项目标准和资质信任信息。"
      },
      breadcrumbSchema([
        { name: "首页", path: "/" },
        { name: "关于我们", path: "/goin" }
      ])
    ]);
  }
};
</script>

<style lang="scss" scoped>
.about-page {
  background: #f5f8f7;
  color: #1f2d3d;
}

.page-hero {
  min-height: 430px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.page-hero img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.page-hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(12, 38, 51, 0.94), rgba(15, 76, 92, 0.68));
}

.page-hero-content,
.section-inner {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
}

.page-hero-content {
  position: relative;
  z-index: 1;
  color: #fff;
}

.breadcrumb {
  display: flex;
  gap: 8px;
  margin-bottom: 26px;
  color: rgba(255, 255, 255, 0.78);
}

.breadcrumb a {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
}

.eyebrow {
  color: #d76b30;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
}

.page-hero h1 {
  max-width: 880px;
  font-size: 42px;
  line-height: 1.25;
  margin: 0 0 18px;
}

.page-hero p {
  max-width: 900px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 17px;
  line-height: 1.9;
}

.section {
  padding: 72px 0;
}

.muted {
  background: #fff;
}

.about-layout,
.standard-layout,
.trust-layout {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 40px;
  align-items: start;
}

h2 {
  color: #0f4c5c;
  font-size: 31px;
  line-height: 1.35;
  margin: 0 0 14px;
}

.about-copy p,
.section-heading p,
.standard-layout p,
.trust-layout p,
.capability-card p,
.standard-item p {
  color: #5c6873;
  line-height: 1.8;
}

.about-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 26px;
}

.btn {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  border-radius: 4px;
  text-decoration: none;
}

.btn-primary {
  color: #fff;
  background: #18736e;
}

.btn-ghost {
  color: #18736e;
  border: 1px solid #18736e;
}

.fact-grid,
.capability-grid,
.trust-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.fact-card,
.capability-card,
.standard-item,
.trust-item {
  border: 1px solid #dce6e4;
  border-radius: 8px;
  background: #fff;
}

.fact-card {
  padding: 26px;
}

.fact-card strong {
  display: block;
  color: #0f4c5c;
  font-size: 28px;
  margin-bottom: 10px;
}

.fact-card span {
  color: #5c6873;
  line-height: 1.7;
}

.section-heading {
  max-width: 780px;
  margin-bottom: 30px;
}

.capability-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.capability-card {
  display: block;
  padding: 26px;
  text-decoration: none;
}

.capability-card i {
  color: #18736e;
  font-size: 28px;
}

.capability-card h3 {
  color: #17313b;
  font-size: 20px;
  margin: 16px 0 10px;
}

.standard-section {
  background: #f5f8f7;
}

.standard-list {
  display: grid;
  gap: 14px;
}

.standard-item {
  display: grid;
  grid-template-columns: 68px 1fr;
  gap: 18px;
  padding: 22px;
}

.standard-item span {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #d76b30;
  color: #fff;
  font-weight: 700;
}

.standard-item h3 {
  color: #17313b;
  margin: 0 0 8px;
}

.trust-item {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 18px;
  color: #17313b;
}

.trust-item i {
  color: #d76b30;
  font-size: 22px;
}

.honor-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-top: 28px;
}

.honor-strip img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border: 1px solid #dce6e4;
  border-radius: 8px;
  background: #fff;
}

.partner-section {
  background: #f5f8f7;
}

.partner-img {
  width: 100%;
  display: block;
  border-radius: 8px;
  border: 1px solid #dce6e4;
  background: #fff;
}

@media (max-width: 980px) {
  .about-layout,
  .standard-layout,
  .trust-layout,
  .fact-grid,
  .capability-grid,
  .trust-grid,
  .honor-strip {
    grid-template-columns: 1fr;
  }

  .page-hero h1 {
    font-size: 34px;
  }
}

@media (max-width: 640px) {
  .page-hero-content,
  .section-inner {
    width: min(100% - 28px, 1180px);
  }

  .page-hero {
    min-height: auto;
    padding: 70px 0;
  }

  .page-hero h1 {
    font-size: 28px;
  }

  .section {
    padding: 52px 0;
  }
}
</style>
